var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#chevron-right-clip)","key":0},React.createElement("path",{"d":"M3.88 22.3467L13.3024 13.1049C13.314 13.0935 13.3295 13.0935 13.3373 13.0821C13.7826 12.6453 13.9995 12.0717 13.9995 11.4981C13.9995 10.9245 13.7826 10.351 13.3373 9.91412C13.3256 9.90273 13.314 9.90273 13.3024 9.89133L3.88 0.649546C2.99701 -0.216515 1.5486 -0.216515 0.661741 0.649546C-0.22512 1.51561 -0.221247 2.93625 0.661741 3.80611L8.50406 11.4981L0.661741 19.1901C-0.221247 20.06 -0.221247 21.4768 0.661741 22.3467C1.5486 23.2165 2.99701 23.2165 3.88 22.3467Z","fill":"#5382DE"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"chevron-right-clip"},React.createElement("rect",{"width":"14","height":"23","fill":"white"})))]);
}

ChevronRight.defaultProps = {"width":"14","height":"23","viewBox":"0 0 14 23","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
